import type React from 'react';

import { Badge, Button, Text } from '@change/ds-core-ui';

import { Translate, TypedTranslate } from '@change-corgi/core-react/i18n';

import { useStarterDashboardV2BreakpointState } from 'src/app/pages/starterDashboardV2/pageContext';
import { useMarkModuleAsLoaded } from 'src/app/pages/starterDashboardV2/shared/contexts';
import { useNextStepsExperiment } from 'src/app/pages/starterDashboardV2/shared/hooks';

import { Task } from './components/Task';
import { useStepsToVictory } from './hooks/useStepsToVictory';

export const StepsToVictory: React.FC = () => {
	const {
		data: { tasks, stats, showDownloadFlyerTask, showTaskListToggle, toggleTaskListLabel, viewMoreRef, getListItemRef },
		actions: { toggleTaskList },
	} = useStepsToVictory();
	const { isMobile } = useStarterDashboardV2BreakpointState();
	const {
		data: { isEnabled: isNextStepsEnabled },
	} = useNextStepsExperiment();
	useMarkModuleAsLoaded('StepsToVictory', !isNextStepsEnabled && stats.count > 0);
	if (isNextStepsEnabled) {
		return null;
	}

	if (stats.count === 0) return null;

	return (
		<div className="bg-background-base flex flex-col gap-6 px-4 py-8 md:p-12">
			<div className="flex w-full items-center">
				<div className="flex items-center gap-3">
					<Text
						className="text-size-heading-small"
						id="steps-to-victory-title"
						data-qa="steps-to-victory-title"
						as="h3"
					>
						<Translate value="corgi.petition.starter_dashboard.steps_to_victory.title" />
					</Text>
					<Badge label={`${stats.completed}/${stats.count}`} size="small" variant="neutral" emphasis="weak" />
				</div>
				{showTaskListToggle && !isMobile && (
					<Button
						variant="tertiary"
						size="small"
						onClick={toggleTaskList}
						data-qa="steps-to-victory-view-more-button"
						ref={viewMoreRef}
						className="bg-fill-transparent text-typography-strong ml-auto"
					>
						<TypedTranslate value={toggleTaskListLabel} />
					</Button>
				)}
			</div>
			{tasks.map((task, index) => {
				if (task.name === 'download_flyer' && !showDownloadFlyerTask) return null;
				return (
					<div key={task.id} ref={getListItemRef(index)} tabIndex={-1}>
						<Task key={task.name} {...task} />
					</div>
				);
			})}
			{showTaskListToggle && isMobile && (
				<Button
					variant="tertiary"
					size="small"
					onClick={toggleTaskList}
					data-qa="steps-to-victory-view-more-button"
					ref={viewMoreRef}
					className="bg-fill-transparent text-typography-strong"
				>
					<TypedTranslate value={toggleTaskListLabel} />
				</Button>
			)}
		</div>
	);
};
